import VueI18n, { LocaleMessages } from 'vue-i18n'
import { BootFileParams } from '@niknevis/vue-modules/types'

function loadLocaleMessages(): LocaleMessages {
  const locales = require.context('../../../../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages: LocaleMessages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default function({ Vue, app, root }: BootFileParams) {
  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'fa',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
  })

  root.exports.i18n = i18n

  app.i18n = i18n
}
